import React from "react";
import type { RouteObject } from "react-router-dom";
import { AgentTnc } from "./pages/tnc/tnc.screen";
import { PkPmkTnc } from "./pages/pk-pmk-tnc/pk-pmk-tnc.screen";
export const routesAgentTnc: RouteObject[] = [
  {
    path: "home",
    index: true,
    element: <AgentTnc />,
  },
  {
    path: "pk-pmk",
    index: true,
    element: <PkPmkTnc />,
  },
];
